// extracted by mini-css-extract-plugin
export var chatHtmlText = "_jx-2";
export var chatLink = "_jx-0";
export var chatText = "_jx-1";